import styled from '@emotion/styled';
import { useUnsafeTranslation } from '../../i18next';

const Container = styled('div')((p) => ({
  fontWeight: p.theme.typography.fontWeightBold
}));

export const OptionalHint = () => {
  const { t } = useUnsafeTranslation();
  return <Container>[{t('Optional')}]</Container>;
};
